import { useworkspaceAuthMeV2Query, WorkspaceStatusEnum } from '@/types/generated/graphql';
import { useHandleOAuthSideEffects } from '@modules/settings/integrations/hooks/use-handle-third-party-oauth-sideeffect';
import { COOKIE_KEY } from '@shared/constants';
import { useBroadcastAuthSubscriber } from '@shared/hooks/use-auth-state-change';
import { rolePrivilegeStore } from '@shared/store/role-privilege.store';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useAppRoute() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const token = Cookies.get(COOKIE_KEY.accessToken);
  const { loggedIn } = rolePrivilegeStore();

  useBroadcastAuthSubscriber();
  useHandleOAuthSideEffects();

  const { data } = useworkspaceAuthMeV2Query({ skip: !token });
  const workspaceStatus = data?.workspaceAuthMeV2?.data?.status;

  let isLoggedIn = false;

  if (loggedIn) isLoggedIn = true;
  else if (workspaceStatus === WorkspaceStatusEnum.pending) isLoggedIn = false;
  else if (token && workspaceStatus) isLoggedIn = true; // when token is present verify there is a workspaceStatus and workspaceStatus is not pending

  // redirect pending workspace to signup complete flow
  // ignore the case for /auth/invitation page
  useEffect(
    function checkPendingWorkspaceStatusAndRedirect() {
      if (workspaceStatus === WorkspaceStatusEnum.pending && !pathname.startsWith('/auth/invitation')) {
        navigate('/select-plan');
      }
    },
    [workspaceStatus]
  );

  return {
    isLoggedIn,
  };
}
